import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import { AuthProvider } from "react-oidc-context";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./store";
import { initI18n } from "../../../packages/i18n/src/config";
import App from "./App";
import "../../../index.css";
import { logout } from "./store/auth";
import { Toaster } from "sonner";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

const i18n = initI18n();

const oidcConfig = {
  authority: import.meta.env.VITE_KEYCLOAK_ISSUER,
  client_id: import.meta.env.VITE_KEYCLOAK_CLIENT_ID,
  post_logout_redirect_uri: window.location.origin,
  scope: "openid profile email",
  revokeTokensOnSignout: true,

  onSignoutCallback: () => {
    store.dispatch(logout());
    localStorage.clear();
    sessionStorage.clear();
  },
};

ReactDOM.createRoot(document.getElementById("root")!).render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <I18nextProvider i18n={i18n}>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <AuthProvider {...oidcConfig}>
              <App />
              <Toaster position="top-right" richColors={true} duration={1500} />
            </AuthProvider>
          </BrowserRouter>
        </QueryClientProvider>
      </I18nextProvider>
    </PersistGate>
  </Provider>
);
